import { useMemo } from 'react';
import { renderMarkdown } from '@/client/lib/markdown';
import { cn } from '@/client/lib/utils';

type MarkdownProps = {
  source: string;
  className?: string;
};

export function Markdown({ source, className }: MarkdownProps) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return (
    <div
      className={cn(
        'prose-cms font-sans text-body text-text-primary leading-relaxed',
        '[&_h1]:font-display [&_h1]:text-h1 [&_h1]:text-primary-dark [&_h1]:mb-6 [&_h1]:tracking-tight',
        '[&_h2]:font-display [&_h2]:text-h2 [&_h2]:text-primary-dark [&_h2]:mt-10 [&_h2]:mb-4 [&_h2]:tracking-tight',
        '[&_h3]:font-display [&_h3]:text-h3 [&_h3]:text-primary-dark [&_h3]:mt-8 [&_h3]:mb-3',
        '[&_h4]:font-display [&_h4]:text-h4 [&_h4]:text-primary-dark [&_h4]:mt-6 [&_h4]:mb-2',
        '[&_p]:my-4 [&_p]:leading-relaxed',
        '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-4',
        '[&_li]:my-1.5 [&_li]:leading-relaxed',
        '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_a]:decoration-primary/30 hover:[&_a]:text-primary-dark hover:[&_a]:decoration-primary',
        '[&_blockquote]:border-l-4 [&_blockquote]:border-primary/40 [&_blockquote]:pl-5 [&_blockquote]:italic [&_blockquote]:text-text-secondary [&_blockquote]:my-6',
        '[&_strong]:font-semibold [&_strong]:text-primary-dark',
        '[&_code]:rounded-md [&_code]:bg-primary/8 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-body-small [&_code]:text-primary-dark',
        '[&_hr]:my-8 [&_hr]:border-glass-border-strong',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
